'use strict';
module.exports = [
    function() {

        return {
            controller: ['$element', 'moment', '$scope', yTimeCtrl],
            controllerAs: 'ctrl',
            template: '{{ model }}',
            scope: {
                yModel: '=model',
                parseOutput: '&',
                parseInput: '&',
            },
            restrict: 'E',
            link: function($scope, $element) {},
        };
    }];

class yTimeCtrl {
    constructor($element, moment, $scope) {
        this.$scope = $scope;

        this.setNewTime();

        this.observeHandler = this.observer.bind(this);
        $scope.yModel.observe(this.observeHandler);
        $scope.$on('$destroy', this.destroy.bind(this));
    }

    observer(event) {
        this.setNewTime()
    }

    setNewTime() {
        let newTime = this.$scope.parseInput({string: this.$scope.yModel.toString()});

        if(!newTime) {
            newTime = moment.tz(this.$scope.yModel.toString(), window.CONFIG.timezone);
        }

        if(newTime.isValid()) {
            let newVal = this.$scope.parseOutput({moment: newTime});

            if(!newVal) {
                newVal = newTime.format();
            }

            this.$scope.model = newVal;
        }
    }

    destroy() {
        this.$scope.yModel.unobserve(this.observeHandler);
    }
}
